import { AbstractControl } from '@angular/forms';

export class customValidators {

  static LengthValidator(levelTypeId: number, isEdit: boolean) {
    return (control: AbstractControl) => {
      if(levelTypeId == 6 && !isEdit || levelTypeId == 8 && isEdit){
        if( control.value) {
          const value = control.value.toString().length;
          if (value != 5 ) {
            return {LengthValidator: true};
          }
        }
      }
      return null;
    };
  }

  static ZoneValidator(levelTypeId: number, levelId: number, isEdit: boolean) {
    return (control: AbstractControl) => {
      if(levelTypeId == 6 && !isEdit || levelTypeId == 8 && isEdit){
        if(control.value ){
          const zone  = Number(levelId.toString().substring(0,3));
          const value = Number(control.value.toString().substring(0,3));
          if (Number(value != zone )) {
            return {ZoneValidator: true};
          }
        }
      }
      
      return null;
    };
  }

}